import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE } from '../../constants'

const defaultState = {
  pending: false,
  resetFailure: false
}

export default (state = defaultState, action) => {

  var newState = {...state}

  switch (action.type){
    case RESET_PASSWORD_REQUEST:
      newState.pending = true;
      newState.resetFailure = false;
      return newState;

    case RESET_PASSWORD_SUCCESS:
      newState.pending = false;
      newState.resetFailure = false;
      return newState;

    case RESET_PASSWORD_FAILURE:
      newState.pending = false;
      newState.resetFailure = true;
      return newState;

    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/password/reset.js